/* SOAR product card swatches — clicking a color swatch swaps the card's
   primary image to that variant and points the card links at the variant.
   Swatches are <span role="button"> elements (no navigation of their own). */

(function () {
  function selectSwatch(card, sw) {
    const img = card.querySelector('.soar-pc__img--primary');
    const url = sw.dataset.imageUrl;
    if (img && url) {
      img.removeAttribute('srcset');
      img.src = url;
    }

    // Swap the hover (second) image to the chosen color's second image.
    const img2 = card.querySelector('.soar-pc__img--secondary');
    const url2 = sw.dataset.imageUrl2;
    if (img2) {
      if (url2) {
        img2.removeAttribute('srcset');
        img2.src = url2;
        card.classList.add('soar-pc--has-2');
      } else {
        img2.removeAttribute('srcset');
        img2.removeAttribute('src');
        card.classList.remove('soar-pc--has-2');
      }
    }

    card.querySelectorAll('[data-soar-swatch]').forEach((s) => s.classList.remove('is-active'));
    sw.classList.add('is-active');

    // Point the card image + title + shop links at the chosen variant.
    const href = sw.dataset.href;
    if (href) {
      card.querySelectorAll('a.soar-pc__link, .card-name a, a.card-shop').forEach((a) => {
        a.href = href;
      });
    }
  }

  function init(root) {
    const cards = root.querySelectorAll('[data-soar-card]');
    cards.forEach((card) => {
      if (card.dataset.swatchesBound === 'true') return;
      card.dataset.swatchesBound = 'true';

      const swatches = card.querySelectorAll('[data-soar-swatch]');
      if (!swatches.length) return;

      swatches.forEach((sw) => {
        sw.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          selectSwatch(card, sw);
        });
        sw.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            selectSwatch(card, sw);
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  // Re-init after section re-render
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  // Custom observer for AJAX swaps in <soar-collection-main>
  const observer = new MutationObserver((muts) => {
    muts.forEach((m) => {
      m.addedNodes.forEach((n) => {
        if (n.nodeType === 1) init(n);
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
